import React from "react";
import { Link } from "react-router-dom";

class WhereTravelling extends React.Component {
  render() {
    const globalStyle = {
      background: "#0076be"
    };
    const style = {
      clear: "both",
      height: "100px"
    };
    return (
      <section className="section whereare">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h1 className="font-weight-bold wherehome">
                  Where are you traveling today?
                </h1>
              </div>
            </div>
          </div>
          {/*<div className="row">
            <div className="col-lg-12">
              <div className="text-center about_content mx-auto">
                <h2 className="wheremid">
                  UNLIMITED* US Data Passes as low as $3 per day.
                </h2>
                * After data cap per day, speed limited to Maximum of 128kbps.
              </div>
            </div>
          </div>*/}

          <div className="col-lg-12">
            <div className="about_box text-center p-3 mt-3">
              <center>
                <Link to="/get-wifi">
                  <button className="usa">USA</button>
                </Link>

                <Link to="/get-wifi/global">
                  <button className="global" style={globalStyle}>
                    GLOBAL
                  </button>
                </Link>
              </center>
              <div style={style} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default WhereTravelling;



// WEBPACK FOOTER //
// ./src/layout/WhereTravelling.js